import * as React from 'react';

const OxxoPaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#oxxo-payment-rebranding_svg__clip0_101_1003)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.373 4 4 9.373 4 16v96c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12zM16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16z"
                fill="#E8E8E7"
            />
            <path
                d="M32.043 27.514c-4.386 0-7.944 3.59-7.944 8.015v.255H168v-.255c0-4.425-3.554-8.015-7.94-8.015H32.043zM168 92.472v-.199H24.1v.2c0 4.425 3.558 8.015 7.944 8.015H160.06c4.386 0 7.94-3.59 7.94-8.016z"
                fill="#FBB110"
            />
            <path
                d="M123.691 63.916c0 11.204 8.999 20.286 20.103 20.286 11.1 0 20.103-9.082 20.103-20.286 0-11.208-9.003-20.29-20.103-20.29-11.104 0-20.103 9.082-20.103 20.29zm-95.846 0c0 11.204 9.003 20.286 20.107 20.286 11.1 0 20.103-9.082 20.103-20.286 0-11.208-9.003-20.29-20.103-20.29-11.104 0-20.107 9.082-20.107 20.29zM168 88.433H68.879c1.786-1.266 3.45-2.997 5.265-5.333l10.097-13.003 4.41 5.624 4.907-6.587-4.29-5.512 10.276-13.238c3.264-4.199-2.977-9.134-6.24-4.935L84.22 57.15l-9.233-11.856c-3.268-4.188-9.496.76-6.229 4.95l10.436 13.382-11.292 14.539c-4.011 5.166-8.015 9.902-15.963 10.268H24.1V39.626h98.6c-1.696 1.25-3.296 2.925-5.031 5.162l-10.093 12.999-4.414-5.62-4.903 6.587 4.29 5.508L92.269 77.5c-3.26 4.199 2.98 9.134 6.24 4.935l9.087-11.697 9.233 11.853c3.268 4.19 9.497-.757 6.229-4.948l-10.435-13.385 11.291-14.535c3.685-4.752 7.367-9.138 14.109-10.097H168v48.807zm-36.242-24.517c0-6.71 5.389-12.147 12.036-12.147 6.646 0 12.031 5.437 12.031 12.147 0 6.707-5.385 12.143-12.031 12.143-6.647 0-12.036-5.436-12.036-12.143zm-95.842 0c0-6.71 5.39-12.147 12.036-12.147 6.642 0 12.031 5.437 12.031 12.147 0 6.707-5.389 12.143-12.031 12.143-6.647 0-12.036-5.436-12.036-12.143z"
                fill="#E70020"
            />
        </g>
        <defs>
            <clipPath id="oxxo-payment-rebranding_svg__clip0_101_1003">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

OxxoPaymentRebrandingSvg.displayName = 'OxxoPaymentRebrandingSvg';
export default OxxoPaymentRebrandingSvg;
